export enum ImportExceptionSubType {
    InvalidCompany = 1,
    InvalidLocation = 2,
    CompanyInactive = 3,
    //  LabAccountNotFound = 4,
    LabAccountAssignedMorethanOneCompany = 5,
    LabAccountNotFoundorNotAssignedtoaCompany = 6,

    InvalidReasonForTest = 1001,
    MoreThanOneTestMatch = 1002,
    TestDoesNotExist = 1003,
    ExistingPendingRandom = 1004,
    DonorDoesNotExist = 1005,
    InvalidDonorID = 1006,
    MoreThanOneDonorMatch = 1007,
    MatchingDonorIsInactive = 1008,
    DonorDoesNotMatch = 1009,

    ChangeMROReportDate = 1501,
    ChangeLabReportDate = 1502,
    ChangeLabAccountTo = 1503,
    ChangeLabCodeFrom = 1504,
    ChangeMROResult = 1505,
    ChangeLabResult = 1506,
    ChangeCollectionDate = 1507,
    ChangeSpecimenType = 1508,
    ChangeReasonForTest = 1509,
    ChangeFederalFlag = 1510,


    InvalidCollectorName = 2001,
    InvalidCollectionDate = 2002,
    InvalidCollectionSite = 2003,
    InvalidPanelCode = 2004,
    InvalidDOTindicator = 2005,
    InvalidOrderedDate = 2006, // obsolete??
    InvalidLabCode = 2007,

    InvalidFirstName = 2008,
    InvalidLastName = 2009,
    InvalidPerson = 2010,
    InvalidLocationRelease = 2011,
    InvalidMROCode = 2012
}


